<template>
    <nav>
        <h1><router-link to="/">• listoliby</router-link></h1>
        <ul>
        <li><router-link :to="{name: 'AllChecklists'}">All Lists</router-link></li>
        <template v-if="$store.getters.isLoggedIn">
            <li><router-link :to="{name: 'CreateChecklist'}">Create List</router-link></li>
            <li><router-link :to="{name: 'UserChecklists'}">Your Lists</router-link></li>
        </template>
        <li><router-link to="/About">About</router-link></li>
        <template v-if="!$store.getters.isLoggedIn">
            <li><router-link to="/login"><i>Login</i></router-link></li>
            <li v-if="$store.getters.signUpAllowed"><router-link to="/signup"><b>Sign up</b></router-link></li>
        </template>
        <template v-else>
            <li><LogoutButton /></li>
        </template>
        </ul>
      </nav>
</template>

<script>
import LogoutButton from '@/components/forms/logout-button.vue'

export default {
    name: 'MainNavigation',
    components: {
        LogoutButton,
    }
}
</script>